var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('base-button',{attrs:{"is-link":"","href":_vm.linkOptions.linkClickUrl,"data-abc":"true"}},[_c('i',{class:_vm.linkOptions.linkIcon}),_vm._v(_vm._s(_vm.linkOptions.linkText)+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }